const setCookie = (
  cookieName: string,
  value: string,
  maxAgeMs: number,
  domain = ".mybenefit.pl"
): void => {
  const maxAgeSec = Math.round(maxAgeMs / 1000);
  document.cookie = `${cookieName}=${value}; max-age=${maxAgeSec}; path=/; domain=${domain}; secure; samesite=lax`;
};

export default setCookie;
